import Button from "@shared/v2/Button";
import PopularCard from "./shared/PopularCard";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const BrivityLeadsPopular = () => {
  const isPlace = useIsPlace();
  return (
    <PopularCard
      title="Brivity Leads"
      description="Whether it’s generating real estate leads or re-engaging your existing database, Brivity’s advertising experts work with you to craft a custom strategy to produce results."
    >
      <Button
        size="medium"
        className={isPlace ? "" : "hs-cta-trigger-button hs-cta-trigger-button-190807761672"}
        onClick={() => {
          if (isPlace) {
            window.open(
              "https://meetings.hubspot.com/amy-gerrish/place-leads-consult?uuid=5244f058-2671-458b-be94-8324fd2ee7b4",
              "_blank",
            );
          }
        }}
      >
        Get More Leads
      </Button>
      <img src="/images/bg-popular-brivity-leads.png" alt="Brivity Leads" />
    </PopularCard>
  );
};

export default BrivityLeadsPopular;
